module.exports = __webpack_public_path__ + "img/multi-mode-2.366a0ce3.png";